import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

import { Company, CrewMember } from '@legacy-types';

import { Icon } from '@shared/ui/components/Icon';
import { cn } from '@shared/utils/helpers';

type ShowUserRegistrationLinkProps = {
  crewMember: CrewMember;
  company: Company;
};

export function ShowUserRegistrationLink({ crewMember, company }: ShowUserRegistrationLinkProps) {
  const history = useHistory();

  // @ts-ignore
  const registrationUrl = `/admin/users/${crewMember.userId}/registrations/${crewMember.registrationId}`;
  const isCurrent = history.location.pathname === registrationUrl;

  return (
    <li className="relative">
      <Link to={registrationUrl} className="group no-underline relative flex items-center py-4">
        <div className={cn('w-8 text-xl text-gray-300', { 'text-indigo-500': isCurrent })}>
          <Icon icon="company" />
        </div>
        <div className="flex-1">
          <div
            className={cn('font-medium text-lg text-gray-500', {
              'text-gray-900': isCurrent,
            })}
          >
            {crewMember.registration!.company!.name}
          </div>
          <div className={cn('flex items-center gap-1 text-gray-500', { 'text-gray-600': isCurrent })}>
            {/* @ts-expect-error */}
            {company.crewAdmin === 1 && <span data-tip="Crew Admin" className="la la-user" />}
            {/* @ts-expect-error */}
            {company.gatekeepingAdmin === 1 && <span data-tip="Gatekeeping Admin" className="la la-truck" />}
            {/* @ts-expect-error */}
            {company.materialAdmin === 1 && <span data-tip="Material Admin" className="la la-wrench" />}
            <span>{crewMember.occupation}</span>
          </div>
        </div>
        <div
          className={cn('w-8 h-8 flex items-center justify-center rounded-full', {
            'bg-indigo-500 text-indigo-100': isCurrent,
            'group-hover:bg-gray-200': !isCurrent,
          })}
        >
          <Icon icon="angle-right" className="rotate-90 2xl:rotate-0" />
        </div>
      </Link>
    </li>
  );
}
